var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.138 3.648a1.808 1.808 0 0 0 1.828-1.831 1.829 1.829 0 0 0-3.657 0 1.845 1.845 0 0 0 1.83 1.831Zm0 6.364a1.8 1.8 0 0 0 1.83-1.8 1.829 1.829 0 1 0-1.83 1.8Zm0 6.408a1.806 1.806 0 0 0 1.828-1.825 1.829 1.829 0 1 0-1.829 1.822l.001.003Z",
    fill: "#AEAEAE"
  })));
};
export default SvgHorizontalPoints;